import { onSnapshot, doc } from "firebase/firestore";
import { db, firebaseConfig } from "@/config/firestore"
import store from "@/store"

const collectionName = firebaseConfig.loginsCollectionName

class LogoutManager {
  constructor(navbar) {
    // we require an instance of the navbar because it has the main logout method
    this.navbar = navbar
  }
  initializeRealtimeLogout() {
    const profileId = store.state.authModule.profileUserId

    this.unsubscribe = onSnapshot(doc(db, collectionName, profileId), (doc) => {
      let document = doc.data()
      if (document && !document.is_logged_in) {
        localStorage.removeItem('user-token')
        window.location.reload()
      }
    });
  }
  destroy() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }
}

export default LogoutManager